import type { UpsertDailyEntryInput } from "@consistency-circle/shared";

export const EMPTY_ENTRY: UpsertDailyEntryInput = {
  wokeOnTime: false,
  walked: false,
  deepWorkDone: false,
  shutdownNoteDone: false,
  phoneFreeBedtime: false,
  mood: null,
  energy: null,
  focus: null,
  brainFog: null,
  motivation: null,
  sleepHours: null,
  sleepQuality: null,
  dietQuality: null,
  exerciseQuality: null,
  notes: null,
  tomorrowFirstTask: null,
};
